"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_forms_1 = require("@carvana/helios-forms");
var test_attributes_1 = require("@carvana/test-attributes");
var PlateEntry_styles_1 = require("./PlateEntry.styles");
var usaStates_1 = __importDefault(require("./usaStates"));
var PlateEntry = function (_a) {
    var plate = _a.plate, _b = _a.plateError, plateError = _b === void 0 ? false : _b, error = _a.error, onBlur = _a.onBlur, plateState = _a.plateState, plateStateError = _a.plateStateError, updatePlate = _a.updatePlate, updatePlateState = _a.updatePlateState;
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var options = usaStates_1.default.map(function (e) { return ({ value: e, label: e }); });
    return ((0, jsx_runtime_1.jsxs)(PlateEntry_styles_1.PlateState, { children: [(0, jsx_runtime_1.jsx)(helios_forms_1.TextInput, __assign({}, getTestAttributes('LicensePlateInput'), { hasError: plateError, error: error, id: "plate", value: plate, label: "License Plate", maxLength: 8, onChange: updatePlate, touched: plateError || (plate === null || plate === void 0 ? void 0 : plate.length) > 0, width: "100%", onBlur: onBlur })), (0, jsx_runtime_1.jsx)(PlateEntry_styles_1.StateWrapper, { children: (0, jsx_runtime_1.jsx)(helios_forms_1.Select, __assign({ className: "stateStyle", label: "State", value: plateState, onChange: updatePlateState, hasError: plateStateError }, { children: options.map(function (o) { return ((0, jsx_runtime_1.jsx)(helios_forms_1.Option, __assign({ value: o.value }, { children: o.label }), o.label)); }) })) })] }));
};
exports.default = PlateEntry;
